import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

import { media, color, transition } from 'components/_settings/variables';
import { Container } from 'components/shared/container';
import { Title } from 'components/shared/title';

import ArrowRightSvg from './icons/arrow-right.svg';

export const WaveImg = styled.img`
  position: absolute;
  bottom: 323px;
  left: -9px;
`;

export const TriangleImg = styled.img`
  position: absolute;
  top: 44px;
  right: -239px;
  ${media.sm} {
    top: 57px;
    right: -84px;
  }
`;

export const TriangleThemePurpleImg = styled.img`
  position: absolute;
  top: 114px;
  right: -239px;
  ${media.sm} {
    top: 57px;
    right: -84px;
  }
`;

export const BackgroundImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

export const StyledLinkArrowIcon = styled(ArrowRightSvg)`
  margin-left: 20px;
  g > g {
    transition: ${transition.base};
  }
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.56;
  color: #a6bbff;
  padding: 20px 0;
  text-decoration: none;
  transition: ${transition.base};

  ${(p) => css`
    ${p.theme === 'light-blue' &&
    css`
      color: #19c7e1;
    `}
    ${p.theme === 'orange' &&
    css`
      color: ${color.text.orangeLight};
    `}
    ${p.theme === 'purple' &&
    css`
      color: ${color.text.purple};
    `}
      ${p.theme === 'purple-dark' &&
    css`
      color: #9e65bc;
    `}
  `},
  &:hover {
    color: ${color.primary};

    ${StyledLinkArrowIcon} {
      g > g {
        stroke: ${color.primary};
      }
    }
  }
`;

export const BottomText = styled.p`
  font-size: 16px;
  line-height: 2.8px;
  color: #ffff;
`;

export const Description = styled.p`
  font-size: 28px;
  line-height: 1.32;
  color: #f2f2f5;
  margin-bottom: 60px;
  ${media.sm} {
    font-size: 24px;
    line-height: 1.33;
    margin-bottom: 40px;
  }
  strong {
    font-weight: normal;
    color: #a6bbff;
    ${(p) => css`
      ${p.theme === 'light-blue' &&
      css`
        color: #19c7e1;
      `}
      ${p.theme === 'orange' &&
      css`
        color: ${color.text.orangeLight};
      `}
      ${p.theme === 'purple' &&
      css`
        color: ${color.text.purpleLight};
      `}
      ${p.theme === 'purple-dark' &&
      css`
        color: #9e65bc;
      `}
    `}
  }
  br {
    ${media.lg} {
      display: none;
    }
  }
`;

export const StyledTitle = styled(Title)`
  font-size: 36px;
  font-weight: normal;
  line-height: 1.63;
  margin-bottom: 50px;
  ${media.md} {
    font-size: 30px;
    font-weight: normal;
    line-height: 1.25;
  }
  ${media.sm} {
    font-size: 32px;
  }
  strong {
    font-weight: 500;
    color: #5871f4;
    ${media.sm} {
      font-weight: normal;
    }
    ${(p) => css`
      ${p.theme === 'light-blue' &&
      css`
        color: #19c7e1;
      `}
      ${p.theme === 'orange' &&
      css`
        color: ${color.text.orangeLight};
      `}
      ${p.theme === 'purple' &&
      css`
        color: ${color.text.purple};
      `}
      ${p.theme === 'purple-dark' &&
      css`
        color: #9e65bc;
      `}
    `}
  }
`;

export const ContentLeft = styled.div`
  padding-top: 47px;
  padding-left: 71px;
  padding-bottom: 61px;
  ${media.lg} {
    padding-top: 47px;
    padding-left: 32px;
  }
  ${media.md} {
    padding-top: 11px;
    padding-left: 32px;
    padding-right: 29px;
    padding-bottom: 31px;
  }
`;

export const ContentRight = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 410px;
  overflow: hidden;

  ${media.md} {
    grid-row-start: 1;
    max-height: 212px;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    display: block;
    z-index: 1;
    border-style: solid;
    border-width: 0 0 410px 149px;
    border-color: transparent transparent transparent #211e51;

    ${media.md} {
      display: none;
    }
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(50, 50, 93, 0.6);
  }
`;

export const Grid = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 751px;
  border-radius: 8px;
  background-color: #211e51;
  overflow: hidden;
  box-shadow: 14px 46px 70px -35px rgba(50, 50, 93, 0.27), 2px 2px 22px 0 rgba(26, 26, 67, 0.01);
  margin-bottom: 85px;
  ${media.lg} {
    grid-template-columns: 1fr 540px;
  }
  ${media.md} {
    grid-template-columns: 12fr;
    margin-bottom: 37px;
  }
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 71px;
    width: 157px;
    height: 8px;
    background-color: #a6bbff;
    ${media.md} {
      display: none;
    }
    ${(p) => css`
      ${p.theme === 'light-blue' &&
      css`
        background-color: #19c7e1;
      `}
      ${p.theme === 'orange' &&
      css`
        background-color: ${color.text.orangeLight};
      `}
      ${p.theme === 'purple' &&
      css`
        background-color: ${color.text.purple};
      `}
      ${p.theme === 'purple-dark' &&
      css`
        background-color: #9e65bc;
      `}
    `}
  }
`;

export const Inner = styled(Container)`
  position: relative;
  z-index: 1;
  @media (min-width: 1378px) {
    max-width: 1318px;
  }
`;

export const Wrapper = styled.section`
  position: relative;
  padding-bottom: 45px;
  margin-bottom: 40px;
`;
